import { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import {
  fetchMedicalProfessional,
  fetchMedicalProfessionalChoices,
} from '~/services/medical-professionals';
import Breadcrumb from '~/components/Breadcrumbs/Breadcrumb';
import ReferralsTab from '~/components/MedicalProfessionalDetail/ReferralsTab';
import NeedVerificationTab from '~/components/MedicalProfessionalDetail/NeedVerificationTab';
import VerifiedPatientsTab from '~/components/MedicalProfessionalDetail/VerifiedPatientsTab';
import Panel from '~/components/Panel';
import Tabs from '~/components/Tabs';
import MedicalProfessionalPanel from '~/components/MedicalProfessionalDetail/MedicalProfessionalPanel';
import MedicalProfessionalTitlePanel from '~/components/MedicalProfessionalDetail/MedicalProfessionalTitlePanel';
import MedicalProfessionalNotes from '~/components/MedicalProfessionalDetail/MedicalProfessionalNotes';

export async function loader({ params }: any) {
  const data = await fetchMedicalProfessional(params.id);
  const professionalChoices = await fetchMedicalProfessionalChoices();
  return { data, professionalChoices };
}

const MedicalProfessionalDetail = () => {
  const { data: medProf, professionalChoices } = useLoaderData() as any;
  const [openTab, setOpenTab] = useState(1);

  const tabNames = [
    { name: 'Need Verification', count: medProf?.unverified_patient_count },
    { name: 'Verified Patients', count: medProf?.verified_patient_count },
    { name: 'Referrals', count: 3 },
  ];

  return (
    <>
      <Breadcrumb
        pageName='Medical Professional Detail'
        parentPage='Medical Professionals'
        parentPath='/medical-professionals'
      />

      <Panel>
        <MedicalProfessionalTitlePanel medProf={medProf} />
      </Panel>

      <div className='mt-7.5 grid grid-cols-12 gap-7.5'>
        <div className='col-span-12 mb-7.5 xl:col-span-8'>
          <div className='mb-7.5'>
            <MedicalProfessionalPanel
              medProf={medProf}
              professionalChoices={professionalChoices}
            />
          </div>

          <Panel>
            <Tabs tabNames={tabNames} openTab={openTab} setOpenTab={setOpenTab}>
              {openTab == 1 ? <NeedVerificationTab id={medProf?.id} /> : ''}
              {openTab == 2 ? <VerifiedPatientsTab id={medProf?.id} /> : ''}
              {openTab == 3 ? <ReferralsTab /> : ''}
            </Tabs>
          </Panel>
        </div>
        <div className='col-span-12 xl:col-span-4'>
          <Panel>
            <MedicalProfessionalNotes
              medProfId={medProf?.id}
              initialNotes={medProf?.notes}
            />
          </Panel>
        </div>
      </div>
    </>
  );
};

export default MedicalProfessionalDetail;
